import React from 'react';
import { sub, add, endOfDay } from 'date-fns';
import { InputAdornment } from '@mui/material';
import Icons, { IconSizes } from '../Icons';

export const PopperPlacements = {
  AUTO: 'auto',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  TOP: 'top',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  LEFT: 'left'
};

export const Orientation = {
  HOR: 'HOR',
  VER: 'VER'
};

export const CUSTOM_RANGE = { label: 'Custom', value: 'custom' };
export const mapDateOptionToRange = (value, options) => {
  const option = options.find(o => o.value === value);
  if (!option || !value) return null;

  const now = Date.now();

  const adjustDate = option.futureDate ? add : sub;
  const from = option.futureDate ? now : adjustDate(now, { [option.unit]: option.amount }).valueOf();
  const to = option.futureDate ? endOfDay(adjustDate(now, { [option.unit]: option.amount })).valueOf() : now;

  return { from, to, option };
};

export const INPUT_PROPS = {
  endAdornment: (
    <InputAdornment position="end">
      <Icons.Calendar fontSize={IconSizes.S} color="var(--select-text-color)" />
    </InputAdornment>
  )
};
